import { paragon as paragonSdk } from "@useparagon/connect";

paragonSdk.configureGlobal({
  host: "eu.paragon.so",
});

export const paragon = paragonSdk;

export { SDK_EVENT } from "@useparagon/connect";
export type {
  AuthenticatedConnectUser,
  FilePickerInitOptions,
  IntegrationInstallEvent,
} from "@useparagon/connect";
